export class CsmService {
  client: any;
  constructor({client}: any) {
    this.client = client;
  }
  getCsmList() {
    return this.client.get(`api/v2/list-csm`, {});
  }
}
